import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from '../ui/button';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_cfa-portal/artifacts/waysuoc0_D35F1E2C-9684-4E11-BB45-5677C422C15C.png";

const navLinks = [
  { href: '/', label: 'Accueil' },
  { href: '/formation', label: 'Formation' },
  { href: '/programme', label: 'Programme' },
  { href: '/planning', label: 'Planning' },
  { href: '/etudiants', label: 'Candidater' },
  { href: '/international', label: 'International' },
  { href: '/espace-etudiant', label: 'Espace Étudiant' },
  { href: '/employeurs', label: 'Employeurs' },
  { href: '/contact', label: 'Contact' },
];

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (href) => {
    if (href === '/') return location.pathname === '/';
    return location.pathname.startsWith(href);
  };

  return (
    <header className="bg-white border-b border-[#E6E6E6] sticky top-0 z-50" data-testid="header">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0" data-testid="header-logo">
            <img 
              src={LOGO_URL} 
              alt="Institut BIA" 
              className="h-14 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                data-testid={`nav-link-${link.label.toLowerCase()}`}
                className={`text-sm font-medium transition-colors ${
                  isActive(link.href)
                    ? 'text-[#C8A75A]'
                    : 'text-[#0B1F3A] hover:text-[#C8A75A]'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex">
            <Link to="/etudiants#candidature">
              <Button 
                className="bg-[#0B1F3A] text-white hover:bg-[#061326] rounded-none px-6"
                data-testid="header-cta"
              >
                Candidater
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-[#0B1F3A]"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-button"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-[#E6E6E6]" data-testid="mobile-menu">
          <nav className="px-6 py-4 space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                onClick={() => setMobileMenuOpen(false)}
                data-testid={`mobile-nav-link-${link.label.toLowerCase()}`}
                className={`block text-base font-medium py-2 ${
                  isActive(link.href)
                    ? 'text-[#C8A75A]'
                    : 'text-[#0B1F3A]'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link to="/etudiants#candidature" onClick={() => setMobileMenuOpen(false)}>
              <Button className="w-full bg-[#0B1F3A] text-white hover:bg-[#061326] rounded-none mt-4">
                Candidater
              </Button>
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
